module.exports = __webpack_public_path__ + "static/img/Jake_Carlisle_desktop.3f3bf87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jake_Carlisle_desktop.jpg
// module id = OApU
// module chunks = 0